import createSuperAgentApiService from "app/pages/sales-intelligence/modules/ai-agent/services/api/superAgentApiService";
import type { IFetchService } from "app/services/fetchService";

import createLeadGeneratorAgentApiService from "../../sub-modules/lead-generator/services/api/leadGeneratorAgentApiService";

import createEmailAgentApiService from "./emailAgentApiService";
import createKnowledgeBaseApiService from "./knowledgeBaseApiService";
import createMeetingAgentApiService from "./meetingAgentApiService";
import createLeadScoringAgentApiService from "./leadScoringAgentApiService";

export const createAiAgentApiService = (apiClient: IFetchService) => {
    return {
        meeting: createMeetingAgentApiService(apiClient),
        email: createEmailAgentApiService(apiClient),
        leadGenerator: createLeadGeneratorAgentApiService(apiClient),
        knowledgeBase: createKnowledgeBaseApiService(apiClient),
        superAgent: createSuperAgentApiService(apiClient),
        leadScoring: createLeadScoringAgentApiService(apiClient),
    };
};
